import React from "react";
import Grid2 from '@mui/material/Grid2';
import EditableFieldsTable from "components/Records/RecordDisplay/EditableFieldsTable";
import BasePaper from "components/Base/BasePaper";

interface FulfillmentDetailsProps {
  fulfilled: boolean;
  itemsLabel?: string;
  numberOfItems: number;
  costPerItem: number;
  fulfilledByPathwaysAvailable?: boolean;
  onSave?: (field: string, value: any) => Promise<void> | void;
}

const FulfillmentDetails: React.FC<FulfillmentDetailsProps> = ({
  fulfilled,
  itemsLabel = "Items",
  numberOfItems,
  costPerItem,
  fulfilledByPathwaysAvailable = false,
  onSave,
}) => {
  const totalCost = (numberOfItems * costPerItem).toFixed(2);

  // Define specific record types for each table
  type UserRecord = {
    numberOfItemsUser: number | string;
    costPerItemUser: string;
    totalCostUser: string;
  };

  type PathwaysRecord = {
    numberOfItemsPathways: number | string;
    costPerItemPathways: string;
    totalCostPathways: string;
  };

  const userRecord: UserRecord = {
    numberOfItemsUser: numberOfItems || "",
    costPerItemUser: costPerItem?.toFixed(2) || "",
    totalCostUser: totalCost || "",
  };

  const pathwaysRecord: PathwaysRecord = {
    numberOfItemsPathways: numberOfItems || "",
    costPerItemPathways: costPerItem?.toFixed(2) || "",
    totalCostPathways: totalCost || "",
  };

  // Explicitly type the field configs so TS knows the allowed keys
  const userFields: { field: keyof UserRecord; label: string }[] = [
    { field: "numberOfItemsUser", label: `Number of ${itemsLabel} to Send` },
    { field: "costPerItemUser", label: `Cost per ${itemsLabel.slice(0, -1)}` },
    { field: "totalCostUser", label: "Total Cost" },
  ];

const pathwaysFields: { field: keyof PathwaysRecord; label: string }[] = [
  { field: "numberOfItemsPathways", label: `Number of ${itemsLabel} to Send` },
  { field: "costPerItemPathways", label: `Cost per ${itemsLabel.slice(0, -1)}` },
  { field: "totalCostPathways", label: "Total Cost" },
];

return (
  <Grid2 container>
    {/* Fulfilled by User */}
    <Grid2 size={fulfilledByPathwaysAvailable ? 6 : 12}>
      <BasePaper dimmed={fulfilled && fulfilledByPathwaysAvailable}>
        <EditableFieldsTable<UserRecord>
          record={userRecord}
          title="Fulfilled by User"
          fields={userFields}
          onSave={(field, value) => onSave?.(field as string, value)}
        />
      </BasePaper>
    </Grid2>

    {/* Fulfilled by Pathways */}
    {fulfilledByPathwaysAvailable && (
      <Grid2 size={6}>
        <BasePaper dimmed={!fulfilled}>
          <EditableFieldsTable<PathwaysRecord>
            record={pathwaysRecord}
            title="Fulfilled by Pathways"
            fields={pathwaysFields}
            onSave={(field, value) => onSave?.(field as string, value)}
          />
        </BasePaper>
      </Grid2>
    )}
  </Grid2>
  );
};

export default FulfillmentDetails;

